module.exports = __webpack_public_path__ + "static/media/worry-time@2x.b47b63a1.png";